export const getRockerboxEmployersRoute = '/rockerbox/employers';
export const getRockerboxEmployerRoute = '/rockerbox/employer';
export const getRockerboxApplicantsRoute = '/rockerbox/applicants';
export const getRockerboxDocumentsRoute = '/rockerbox/documents';
export const updateRockerboxWotcRoute = '/rockerbox/enable-wotc/';
export const updatePayrateRoute = '/rockerbox/applicants/update/';
export const deleteApplicantRoute = '/wotc/survey/applicant/delete/';
export const uploadDocumentRoute = '/rockerbox/documents/';